import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withKeys as _withKeys, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "flex gap-4 justify-between items-center flex-wrap pt-7 pb-7" }
const _hoisted_2 = { class: "main-menu flex gap-2 items-center max-md:hidden" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "grow flex justify-end items-center gap-3.5" }
const _hoisted_5 = { class: "flex border border-black/10 dark:border-white/[.14] rounded-full overflow-hidden text-[13px] font-bold select-none" }
const _hoisted_6 = {
  key: 0,
  class: "md:hidden fixed inset-0 z-50"
}
const _hoisted_7 = { class: "menu-panel absolute top-0 right-0 h-full w-[min(320px,84vw)] flex flex-col p-5 bg-bg dark:bg-bg-dark border-l border-black/10 dark:border-white/[.14] shadow-[-18px_0_40px_rgba(0,0,0,0.18)]" }
const _hoisted_8 = ["href"]

import { computed, onBeforeUnmount, ref, watch, type Component } from 'vue';
import { useI18n } from 'vue-i18n';
import { routes } from '@/router/index';
import useChangeTheme from '@/composable/useChangeTheme';
import { LINK_TO_GIT } from '@/constants/general';
import { English, Russian } from '@/locales';
import VSvgComponent from './VSvgComponent.vue';
import russianFlag from '@/assets/icons/russian_flag.vue';
import engFlag from '@/assets/icons/eng_flag.vue';
import { mdiWhiteBalanceSunny, mdiMoonWaningCrescent, mdiMenu, mdiClose, mdiOpenInNew } from '@mdi/js';


export default /*@__PURE__*/_defineComponent({
  __name: 'VHeader',
  setup(__props) {

const { t, locale } = useI18n();
const { toggleTheme, isThemeDark: isDark } = useChangeTheme();

const currentLocale = computed<string>({
    get: () => locale.value,
    set: (value: string) => { locale.value = value; }
});

const flags = computed<{
    viewBox: string,
    component: Component,
    show: boolean,
}[]>(() => [
    {
        viewBox: '0 0 55.2 38.4',
        component: engFlag,
        show: currentLocale.value === English

    },
    {
        viewBox: '0 0 9 6',
        component: russianFlag,
        show: currentLocale.value === Russian
    }
]);

const isMenuOpen = ref(false);

const changeLocale = () => {
    if (currentLocale.value === English) {
        currentLocale.value = Russian;
        localStorage.setItem('locale', Russian);
    } else {
        currentLocale.value = English;
        localStorage.setItem('locale', English);
    }
};

const links = computed(() => routes
    .filter(({ meta }) => !meta?.isSubDirectory && meta?.as !== 'link'));

const closeMenu = () => {
    isMenuOpen.value = false;
};

const onMenuKey = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
        closeMenu();
    }
};

// Пока меню открыто, страница под ним не должна прокручиваться
watch(isMenuOpen, (open) => {
    document.body.style.overflow = open ? 'hidden' : '';

    if (open) {
        window.addEventListener('keydown', onMenuKey);
    } else {
        window.removeEventListener('keydown', onMenuKey);
    }
});

onBeforeUnmount(() => {
    document.body.style.overflow = '';
    window.removeEventListener('keydown', onMenuKey);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "router-link router-link--home py-2.5 px-4 rounded-lg font-medium transition-colors",
        to: "/"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('general.about')), 1)
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(links.value, (item, index) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          class: "router-link py-2.5 px-4 rounded-lg font-medium transition-colors",
          key: index,
          to: item.path
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)(item.name as string)), 1)
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 128)),
      _createElementVNode("a", {
        class: "flex items-center gap-1 py-2.5 px-4 rounded-lg font-medium text-soft dark:text-soft-dark hover:underline",
        target: "_blank",
        rel: "noopener noreferrer",
        href: _unref(LINK_TO_GIT)
      }, [
        _createTextVNode(_toDisplayString(_unref(t)('general.source')) + " ", 1),
        _createVNode(VSvgComponent, {
          icon: _unref(mdiOpenInNew),
          width: "14px",
          height: "14px",
          class: "fill-soft dark:fill-soft-dark"
        }, null, 8, ["icon"])
      ], 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", {
          class: _normalizeClass(["py-1.5 px-3 cursor-pointer transition-colors", currentLocale.value === _unref(Russian)
                        ? 'bg-mint dark:bg-mint-dark text-onmint dark:text-white'
                        : 'text-soft dark:text-soft-dark']),
          onClick: changeLocale
        }, "RU", 2),
        _createElementVNode("span", {
          class: _normalizeClass(["py-1.5 px-3 cursor-pointer transition-colors", currentLocale.value === _unref(English)
                        ? 'bg-mint dark:bg-mint-dark text-onmint dark:text-white'
                        : 'text-soft dark:text-soft-dark']),
          onClick: changeLocale
        }, "EN", 2)
      ]),
      _createVNode(VSvgComponent, {
        fill: _unref(isDark) ? 'yellow' : 'MediumSlateBlue',
        icon: _unref(isDark) ? _unref(mdiWhiteBalanceSunny) : _unref(mdiMoonWaningCrescent),
        "aria-label": _unref(t)('general.toggleTheme'),
        role: "button",
        tabindex: "0",
        class: "focus-visible:ring-2 focus-visible:ring-mintline dark:focus-visible:ring-mintline-dark focus-visible:outline-none rounded-full",
        onClick: _unref(toggleTheme),
        onKeydown: _withKeys(_unref(toggleTheme), ["enter"])
      }, null, 8, ["fill", "icon", "aria-label", "onClick", "onKeydown"]),
      _createVNode(VSvgComponent, {
        class: "md:hidden ml-2 dark:fill-white focus-visible:ring-2 focus-visible:ring-mintline dark:focus-visible:ring-mintline-dark focus-visible:outline-none rounded-full",
        viewBox: "0 0 24 24",
        icon: _unref(mdiMenu),
        "aria-label": _unref(t)('general.openMenu'),
        role: "button",
        tabindex: "0",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (isMenuOpen.value = true)),
        onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (isMenuOpen.value = true), ["enter"]))
      }, null, 8, ["icon", "aria-label"]),
      _createVNode(_Transition, { name: "menu" }, {
        default: _withCtx(() => [
          (isMenuOpen.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: "absolute inset-0 bg-ink/50 dark:bg-black/70 backdrop-blur-sm",
                  onClick: closeMenu
                }),
                _createElementVNode("nav", _hoisted_7, [
                  _createVNode(VSvgComponent, {
                    class: "self-end mb-4 fill-ink dark:fill-ink-dark focus-visible:ring-2 focus-visible:ring-mintline dark:focus-visible:ring-mintline-dark focus-visible:outline-none rounded-full",
                    width: "26px",
                    height: "26px",
                    icon: _unref(mdiClose),
                    "aria-label": _unref(t)('general.closeMenu'),
                    role: "button",
                    tabindex: "0",
                    onClick: closeMenu,
                    onKeydown: _withKeys(closeMenu, ["enter"])
                  }, null, 8, ["icon", "aria-label"]),
                  _createVNode(_component_router_link, {
                    class: "router-link router-link--home menu-link",
                    to: "/",
                    onClick: closeMenu
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('general.about')), 1)
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(links.value, (item, index) => {
                    return (_openBlock(), _createBlock(_component_router_link, {
                      key: index,
                      class: "router-link menu-link",
                      to: item.path,
                      onClick: closeMenu
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)(item.name as string)), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  }), 128)),
                  _createElementVNode("a", {
                    class: "menu-link flex items-center gap-2 text-soft dark:text-soft-dark",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    href: _unref(LINK_TO_GIT),
                    onClick: closeMenu
                  }, [
                    _createTextVNode(_toDisplayString(_unref(t)('general.source')) + " ", 1),
                    _createVNode(VSvgComponent, {
                      icon: _unref(mdiOpenInNew),
                      width: "16px",
                      height: "16px",
                      class: "fill-soft dark:fill-soft-dark"
                    }, null, 8, ["icon"])
                  ], 8, _hoisted_8)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})